
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component
export default class AnswerBlockDatepicker extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex!: number;
  @Prop({ type: Boolean, default: true }) readonly fit!: boolean;

  @Watch("input")
  updateAnswer(value: string) {
    if (this.index == null) return;

    SMQuestionnaire.updateAnswer({
      index: this.index,
      value,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });

    this.$emit("set-date", {
      value,
      element: this.$el,
    });
  }

  input = "";

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index != null && answer) this.input = answer.value;
  }

  get tillPresent() {
    return this.answerBlockData?.till_present;
  }

  get fromPresent() {
    return this.answerBlockData?.from_present;
  }

  get maxDate() {
    return this.answerBlockData?.max_date || null;
  }

  get minDate() {
    return this.answerBlockData?.min_date || null;
  }

  get errors() {
    return SMQuestionnaire.errors;
  }

  rules = [
    () => {
      const error = this.errors.find(
        (error) =>
          error.loop_index === this.loopIndex && error.answer_block_id === this.answerBlockData?.ID
      );

      if (error) {
        this.validate(false);

        if (!this.$refs.input) return;

        Object.assign(this.$refs.input, { valid: false });

        // ((this.$refs.input as unknown) as any).flushAndSetInvalid?.();

        ((this.$refs.input as unknown) as any).$emit("showError");

        return error.error_message;
      }

      return null;
    },
  ];

  validate(valid: boolean) {
    if (this.input && !valid) SMQuestionnaire.setCanGoNext(false);
  }
}
